import { ApiResponse } from '@/domain'
import { useToast } from '@/hooks/use-toast'
import { documentsApi } from '@/rest/modules/documents-api'
import { useMutation } from '@tanstack/react-query'

export const useDownloadDocument = () => {
  const { toast } = useToast()

  return useMutation({
    mutationFn: ({ documentId }: {
      documentId: string;
      fileName: string;
    }) => documentsApi.downloadDocument(documentId),
    onSuccess: (response: any, variables: { documentId: string; fileName: string }) => {
      const url = window.URL.createObjectURL(response)
      const link = document.createElement('a');
      link.href = url;
      link.download = variables.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    },
    onError: (response: ApiResponse<any>) => {
      toast({
        title: 'Error',
        description: response.message || response.error || 'Error al descargar el documento',
        variant: 'destructive',
      })
    },
  })
}

export const useOpenDocument = () => {
  const { toast } = useToast()

  return useMutation({
    mutationFn: ({ documentId }: {
      documentId: string;
      fileName: string;
    }) => documentsApi.downloadDocument(documentId),
    onSuccess: (response: any) => {
      const url = window.URL.createObjectURL(response)
      window.open(url, '_blank')
    },
    onError: (response: ApiResponse<any>) => {
      toast({
        title: 'Error',
        description: response.message || response.error || 'Error al abrir el documento',
        variant: 'destructive',
      })
    },
  })
}
